exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".right-content__main{\n  /* width: 31rem; */\n  padding: 24px 20px;\n}\n.right-content__top{\n  margin-bottom: 20px;\n}\n.information__main{\n  margin-bottom: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/modules/rightContent/rightContent.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/modules/rightContent/rightContent.css
// module chunks = 120